import React from 'react';

function StatRow({ label, value, total }) {
  const pct = total > 0 ? Math.round((value / total) * 100) : 0;
  return (
    <div className="flex items-center gap-3 py-2 px-2 -mx-2 rounded-lg transition-colors hover:bg-[#f8f5ef]">
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-1">
          <span className="text-[12px] font-medium text-[#08111f] truncate">{label}</span>
          <span className="text-[11px] text-[#7a7060]">{value}</span>
        </div>
        <div className="h-[5px] rounded-full overflow-hidden bg-[#e8e2d6]">
          <div className="h-full rounded-full transition-all" style={{ width: `${pct}%`, background: '#145f5f' }} />
        </div>
      </div>
    </div>
  );
}

export default StatRow;
